import { useEffect, useState } from "react";

export default function useTheme() {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("fleet-theme") || "light";
  });

  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
    localStorage.setItem("fleet-theme", theme);
  }, [theme]);

  return { theme, toggleTheme: () => setTheme(t => t === "light" ? "dark" : "light") };
}